/*
  File name: vuetify.js
    Program Description:
    - This plugin modifies the built-in configuration of the vuetify library to
    override default colors, and icons of the system.
*/

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    themes: {
      light: {
        primary: '#272A68',
        secondary: '#FDDA63',
        danger: '#A32929',
        success: '#218100',
        disable: '#B6B6B6',
        export: '#0066DD',
        status_closed: '#A22929',
        status_investigation: '#795548',
        status_pdbnf_review: '#3B6EF1',
        status_fbner_review: '#009688',
        status_show_cause: '#757575',
        status_initial_order: '#3F51B5'
      }
    }
  }
})
